export default {
  isLoading: (state) => (action) => {
    return !!state.loadingStates[action];
  },
};
